import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";

import AttachmentFactory from "../../Entity/Factories/AttachmentFactory";
import PersonFactory from "../../Entity/Factories/PersonFactory";
import CompanyFactory from "../../Entity/Factories/CompanyFactory";
import PropertyFactory from "../../Entity/Factories/PropertyFactory";
import UnitFactory from "../../Entity/Factories/UnitFactory";
import ContractFactory from "../../Entity/Factories/ContractFactory";
import ChargeFactory from "../../Entity/Factories/ChargeFactory";
import EventFactory from "../../Entity/Factories/EventFactory";
import ConversationFactory from "../../Entity/Factories/ConversationFactory";

import { ActionInterface } from "../../Interface/ActionInterface";
import { AttachmentInterface } from "../../Entity/Entities/Attachment/AttachmentInterface";
import { PersonInterface } from "../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../Entity/Entities/Company/CompanyInterface";
import { PropertyInterface } from "../../Entity/Entities/Property/PropertyInterface";
import { UnitInterface } from "../../Entity/Entities/Unit/UnitInterface";
import { ContractInterface } from "../../Entity/Entities/Contract/ContractInterface";
import { ChargeInterface } from "../../Entity/Entities/Charge/ChargeInterface";
import { EventInterface } from "../../Entity/Entities/Event/EventInterface";
import { ConversationInterface } from "../../Entity/Entities/Conversation/ConversationInterface";

export default function* attachmentCreate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_ATTACHMENT_UPLOAD_REQUEST,
      payload: {
        typeOfComponent: action.payload?.typeOfComponent
      }
    });

    const res = yield call(Http.post, "attachment", action.payload?.attachmentData);

    // If we are creating an entity, just put the attahchment into the component.
    if (res.data.created === true) {
      const attachment: AttachmentInterface = AttachmentFactory.create(res.data.data);
      yield put({
        type: Constants.GLOBAL_ATTACHMENT_UPLOAD_SUCCESS,
        payload: {
          typeOfComponent: action.payload?.typeOfComponent
        }
      });

      if (action.hasOwnProperty("onSuccess") === true) {
        action.onSuccess.call(this, attachment);
      }
    } else {
      // If we have an entity to update, let's update it.
      switch (action.payload?.attachmentData.relation) {
        case "contactId":
          const person: PersonInterface = PersonFactory.create(res.data.data);

          yield put({
            type: Constants.GLOBAL_ATTACHMENT_PERSON_UPLOAD_SUCCESS,
            payload: {
              person: person
            }
          });

          yield put({
            type: Constants.GLOBAL_ATTACHMENT_UPLOAD_SUCCESS
          });

          if (action.hasOwnProperty("onSuccess") === true) {
            action.onSuccess.call(this, person.attachments);
          }
        break;

        case "companyId":
          const company: CompanyInterface = CompanyFactory.create(res.data.data);

          
          yield put({
            type: Constants.GLOBAL_ATTACHMENT_COMPANY_UPLOAD_SUCCESS,
            payload: {
              company: company
            }
          });

          yield put({
            type: Constants.GLOBAL_ATTACHMENT_UPLOAD_SUCCESS
          });

          if (action.hasOwnProperty("onSuccess") === true) {
            action.onSuccess.call(this, company.attachments);
          }
        break;

        case "agencyId":
          const agency: CompanyInterface = CompanyFactory.create(res.data.data);

          yield put({
            type: Constants.GLOBAL_ATTACHMENT_COMPANY_UPLOAD_SUCCESS,
            payload: {
              company: agency
            }
          });

          yield put({
            type: Constants.GLOBAL_ATTACHMENT_AGENCY_UPLOAD_SUCCESS,
            payload: {
              agency: agency
            }
          });

          yield put({
            type: Constants.GLOBAL_ATTACHMENT_UPLOAD_SUCCESS
          });

          if (action.hasOwnProperty("onSuccess") === true) {
            action.onSuccess.call(this, agency.attachments);
          }
        break;

        case "propertyId":
          const property: PropertyInterface = PropertyFactory.create(res.data.data);

          yield put({
            type: Constants.GLOBAL_ATTACHMENT_PROPERTY_UPLOAD_SUCCESS,
            payload: {
              property: property
            }
          });

          yield put({
            type: Constants.GLOBAL_ATTACHMENT_UPLOAD_SUCCESS
          });

          if (action.hasOwnProperty("onSuccess") === true) {
            action.onSuccess.call(this, property.attachments);
          }
        break;

        case "unitId":
          const unit: UnitInterface = UnitFactory.create(res.data.data);

          yield put({
            type: Constants.GLOBAL_ATTACHMENT_UNIT_UPLOAD_SUCCESS,
            payload: {
              unit: unit
            }
          });

          yield put({
            type: Constants.GLOBAL_ATTACHMENT_UPLOAD_SUCCESS
          });

          if (action.hasOwnProperty("onSuccess") === true) {
            action.onSuccess.call(this, unit.attachments);
          }
        break;

        case "contractId":
          const contract: ContractInterface = ContractFactory.create(res.data.data);

          yield put({
            type: Constants.GLOBAL_ATTACHMENT_CONTRACT_UPLOAD_SUCCESS,
            payload: {
              contract: contract
            }
          });

          yield put({
            type: Constants.GLOBAL_ATTACHMENT_UPLOAD_SUCCESS
          });

          if (action.hasOwnProperty("onSuccess") === true) {
            action.onSuccess.call(this, contract.attachments);
          }
        break;

        case "chargeId":
          const charge: ChargeInterface = ChargeFactory.create(res.data.data);

          yield put({
            type: Constants.GLOBAL_ATTACHMENT_CHARGE_UPLOAD_SUCCESS,
            payload: {
              charge: charge
            }
          });

          yield put({
            type: Constants.GLOBAL_ATTACHMENT_UPLOAD_SUCCESS
          });

          if (action.hasOwnProperty("onSuccess") === true) {
            action.onSuccess.call(this, charge.attachments);
          }
        break;

        case "eventId":
          const event: EventInterface = EventFactory.create(res.data.data);

          yield put({
            type: Constants.GLOBAL_ATTACHMENT_EVENT_UPLOAD_SUCCESS,
            payload: {
              event: event
            }
          });

          yield put({
            type: Constants.GLOBAL_ATTACHMENT_UPLOAD_SUCCESS
          });

          if (action.hasOwnProperty("onSuccess") === true) {
            action.onSuccess.call(this, event.attachments);
          }
        break;

        case "conversationId":
          const conversation: ConversationInterface = ConversationFactory.create(res.data.data);

          yield put({
            type: Constants.GLOBAL_ATTACHMENT_CONVERSATION_UPLOAD_SUCCESS,
            payload: {
              conversation: conversation
            }
          });

          yield put({
            type: Constants.GLOBAL_ATTACHMENT_UPLOAD_SUCCESS
          });

          if (action.hasOwnProperty("onSuccess") === true) {
            action.onSuccess.call(this, conversation.attachments);
          }
        break;

        default:
          break;
      }
    }

  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_ATTACHMENT_UPLOAD_FAILURE,
      payload: {
        err: err,
        typeOfComponent: action.payload?.typeOfComponent
      }
    });
  }
}

export function* watchAttachmentCreate() {
  yield takeEvery(Constants.GLOBAL_ATTACHMENT_UPLOAD_START, attachmentCreate);
}
